module.exports = __webpack_public_path__ + "static/media/caretRight.1e56cad1.svg";